// src/components/ControlDePagos.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import config from "./../config";
//import axios from 'axios';
import { DownOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import {
  Breadcrumb, Layout,
  Typography,
  Select,
  Input,
  Button,
  Divider,
  Table,
  Row,
  Col,
  Card,
  Spin,
  message,
  Dropdown,
  Space,
  Popconfirm
} from 'antd';
import axios from "./../services/http";
import DownloadFile from '../utils/DownloadFile';
import GridDatosGenerales from "./../modules/ControlDePago/GridDatosGenerales";
import GridPresupuestoInicial from "./../modules/ControlDePago/GridPresupuestoInicial";
import GridPresupuestoObra from "./../modules/ControlDePago/GridPresupuestoObra";
import GridContratoSNIva from "./../modules/ControlDePago/GridContratoSNIva";
import GridContratoIva from "./../modules/ControlDePago/GridContratoIva";
import GridResumenGeneral from "./../modules/ControlDePago/GridResumenGeneral";
import GridResumenGeneralContrato from "./../modules/ControlDePago/GridResumenGeneralContrato";
import GridResumenGeneralContratoSIva from "./../modules/ControlDePago/GridResumenGeneralContratoSIva";
import ModalEditarPresupuestoCmp from '../modules/ControlDePago/ModalEditarPresupuestoCmp';
import { jwtDecode } from 'jwt-decode'; 
import { use } from 'react';
const { Content } = Layout;

const { Option } = Select;

const ControlDePagos = ({ goBack }) => {

  const location = useLocation();
  const { from, contratista_id, cp } = location.state;
  const navigate = useNavigate();

  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [usuario, setUsuario] = useState(jwtDecode(token));
  const [obraId, setObraId] = useState(null);
  const [contratistas, setContratistas] = useState([]);
  const [selectedContratista, setSelectedContratista] = useState('');
  const [selectedNameContratista, setSelectedNameContratista] = useState('');
  const [controlesDePago, setControlesDePago] = useState([]);
  const [selectedControlPago, setSelectedControlPago] = useState('');
  const [controlPago, setControlPago] = useState(null);
  const [gastos, setGastos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [historical, setHistorical] = useState(null);
  const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});
  const numberFormatCurrency = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
  const items = [{
    key: '1',
    label: (
      <a target="_blank" rel="noopener noreferrer" href={controlPago !== null && controlPago !== undefined ? `${config.server}/static/documents/${controlPago.ruta_imagen_presupuesto}` : null}>
        <EyeOutlined /> Ver
      </a>
    ),
  }, {
    key: '2',
    label: (
      <a target="_blank" rel="noopener noreferrer" 
        onClick={() => DownloadFile((controlPago !== null ? `${config.server}/static/documents/${controlPago.ruta_imagen_presupuesto}` : null), (controlPago !== null && controlPago !== undefined ? controlPago.ruta_imagen_presupuesto : null))}>
        <DownloadOutlined /> Descargar {controlesDePago.ruta_imagen_presupuesto}
      </a>
    ),
  }];

  useEffect(() => {
    if (!obraId) return;

    const fetchContratistas = async () => {
      setLoading(true);
      try {
        const response = await axios.HTTP_GET(`/api/v1/catalogs/contratistas/${obraId}`);
        if (response) setContratistas(response);
      } catch (error) {
        console.error('Error al cargar los contratistas:', error);
        message.error('Error al cargar los contratistas');
      } finally {
        setLoading(false);
      }
    };

    fetchContratistas();

    if (contratista_id) {
      fetchControlesDePago(contratista_id);
    }
  }, [obraId]);

  useEffect(() => {
    if (from) {
      setObraId(from.id);
    }

    if (from && contratista_id && cp) {
      console.log("from**", from, contratista_id, cp);
      handleContratistaChange(contratista_id);
      setSelectedControlPago(cp);
    }
  }, [from, contratista_id, cp]);

  const fetchControlesDePago = async (contratistaId) => {
    setLoading(true);
    try {
      let data = [];
      const response = await axios.HTTP_GET(`/api/v1/catalogs/controlesdepago/${obraId}/${contratistaId}`);
      if (response){
        data = response;
        setControlesDePago(data);

        if (contratista_id && cp) fetchControlDePagoDetailsV2(cp, data);
      }
      // if (Array.isArray(data)) {
        
      // } else if (data === null || data === undefined) {
      //   setControlesDePago([]);
      // } else {
      //   setControlesDePago([data]);
      // }
      
    } catch (error) {
      console.error('Error al obtener los controles de pago:', error);
      message.error('Error al obtener los controles de pago');
      setControlesDePago([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchControlDePagoDetails = async (controlPagoId) => {
    setLoading(true);
    try {
      const selectedControl = controlesDePago.find(
        (cp) => cp.id === parseInt(controlPagoId)
      );
      setControlPago(selectedControl);

      const gastosResponse = await axios.HTTP_GET(
        `/api/v1/catalogs/relaciones/${obraId}/${controlPagoId}`
      );
      if (gastosResponse) setGastos(gastosResponse);

      GetHistoricalCp(controlPagoId);

    } catch (error) {
      console.error('Error al cargar el control de pagos:', error);
      message.error('Error al cargar el control de pagos');
    } finally {
      setLoading(false);
    }
  };

  const fetchControlDePagoDetailsV2 = async (controlPagoId, controles) => {
    setLoading(true);
    try {
      const selectedControl = controles.find(
        (cp) => cp.id === parseInt(controlPagoId)
      );
      setControlPago(selectedControl);

      const gastosResponse = await axios.HTTP_GET(
        `/api/v1/catalogs/relaciones/${obraId}/${controlPagoId}`
      );
      if (gastosResponse) setGastos(gastosResponse);

      GetHistoricalCp(selectedControl);

    } catch (error) {
      console.error('Error al cargar el control de pagos:', error);
      message.error('Error al cargar el control de pagos');
    } finally {
      setLoading(false);
    }
  };

  const GetHistoricalCp = async (cp_id) => {
    try {
      setLoading(true);
      
      const historical = await axios.HTTP_GET(`/api/v1/cp/historical/get/${cp_id}`);
      console.log("historical***", historical);
      setHistorical(historical);

    } catch (e) {
      console.error('Error al cargar el historico de control de pagos:', e);
      message.error('Error al cargar el historico de control de pagos');
    } finally {
      setLoading(false);
    }
  }

  const handleContratistaChange = (value) => {
    const contratistaId = value;
    setSelectedContratista(contratistaId);
    setSelectedControlPago('');
    setControlPago(null);
    setGastos([]);
    fetchControlesDePago(contratistaId);
  };

  const handleControlPagoChange = (value) => {
    const controlPagoId = value;
    setSelectedControlPago(controlPagoId);
    fetchControlDePagoDetails(controlPagoId);

    setSelectedNameContratista(contratistas.find(c => c.id === controlPagoId)?.nombre_contratista || '-');
  };

  const CancelCP = async () => {
    setLoading(true);
    try {
      const response = await axios.HTTP_POST("/api/v1/cp/delete", { cp_id: selectedControlPago });
      if (response && response.data && response.data.success) {
        message.success(response.data.message);
        Navigate("/home", { state: { from: from } } )
      }
    } catch (error) {
      console.error('Error al eliminar el control de pagos:', error);
      message.error('Error al eliminar el control de pagos');
    } finally {
      setLoading(false);
    }
  }

  const calculateValues = () => {
    if (!controlPago) return {};

    const presupuesto =  parseFloat(controlPago.presupuesto) || 0;
    const presupuesto_no_iva = parseFloat(controlPago.presupuesto_no_iva) || 0;
    const presupuesto_iva = parseFloat(controlPago.presupuesto_iva) || 0;
    const ivaPorcentaje = parseFloat(controlPago.iva) || 0;
    const anticipoFiscal = parseFloat(controlPago.anticipoFiscal) || 0;
    const anticipoNoFiscal = parseFloat(controlPago.anticipoNoFiscal) || 0;

    const ivaFactor = ivaPorcentaje / 100;

    const ivaCalculado = presupuesto * ivaFactor;
    //const ivaSinIva = presupuesto_no_iva * ivaFactor;
    //const ivaConIva = presupuesto_iva * ivaFactor;
    const ivaSinIva = 0;
    const ivaConIva = ivaPorcentaje;

    const montosNoFiscales = gastos.filter((gasto) => gasto.tipo_monto === 'No Fiscal');
    const montosFiscales = gastos.filter((gasto) => gasto.tipo_monto === 'Fiscal');

    const montoNoFiscalSinAbonos = montosNoFiscales.filter((gasto) => gasto.tipo !== "ABONO");
    const montoFiscalSinAbonos = montosFiscales.filter((gasto) => gasto.tipo !== "ABONO");

    const totalNoFiscalSinAbono = montoNoFiscalSinAbonos.reduce(
      (acc, gasto) => acc + parseFloat(gasto.importe || 0),
      0
    );
    const totalFiscalSinAbono = montoFiscalSinAbonos.reduce(
      (acc, gasto) => acc + parseFloat(gasto.importe || 0),
      0
    );
    const totalFiscalIvaSinAbono = montoFiscalSinAbonos.reduce(
      (acc, gasto) => acc + parseFloat((gasto.importe+(gasto.importe*ivaFactor)) || 0),
      0
    );

    const totalNoFiscal = montosNoFiscales.reduce(
      (acc, gasto) => acc + parseFloat(gasto.importe || 0),
      0
    );
    const totalFiscal = montosFiscales.reduce(
      (acc, gasto) => acc + parseFloat(gasto.importe || 0),
      0
    );
    const totalFiscalIva = montosFiscales.reduce(
      (acc, gasto) => acc + parseFloat((gasto.importe+(gasto.importe*ivaFactor)) || 0),
      0
    );

    // console.log("totalNoFiscal**", totalNoFiscal);
    // console.log("totalFiscal**", totalFiscal);
    // console.log("ivaFactor**", ivaFactor);
    //const totalEstimado = totalNoFiscal + totalFiscal + totalFiscal * ivaFactor;
    const totalEstimadoSinAbono = totalNoFiscalSinAbono + totalFiscalSinAbono;
    const totalEstimado = totalNoFiscal + totalFiscal;
    const presupuestoRealTotal = presupuesto + ivaCalculado;
    const saldoReal = presupuestoRealTotal - totalEstimado;
    const finiquito = saldoReal / presupuestoRealTotal;

    /** CONTRATO SIN IVA **/
    const presupuestoSinIva = presupuesto * (presupuesto_no_iva / 100);

    /** CONTRATO IVA **/
    const presupuestoIva = presupuesto * (presupuesto_iva/100);
    const presupuestoIvaConIva = presupuestoIva * (ivaPorcentaje/100);
    const presupuestoRealIva = presupuestoIva + presupuestoIvaConIva;

    const contratoIva = totalFiscal + anticipoFiscal;
    const contratoConIva = contratoIva * (ivaPorcentaje/100);
    const contratoTotalIva = contratoIva + contratoConIva;
    const anticipoIva = anticipoFiscal * (ivaPorcentaje/100);
    const anticipoTotalIva = anticipoFiscal + anticipoIva;

    /** RESUMEN GENERAL **/
    const presupuestoReal = presupuestoSinIva + presupuestoIva;
    const anticipoReal = anticipoNoFiscal + anticipoFiscal;


    return {
      presupuesto,
      presupuesto_no_iva,
      presupuesto_iva,
      ivaCalculado,
      ivaSinIva,
      ivaConIva,
      ivaPorcentaje,
      ivaFactor,
      montosNoFiscales,
      montosFiscales,
      totalNoFiscal,
      totalFiscal,
      totalEstimado,
      presupuestoRealTotal,
      saldoReal,
      finiquito,
      presupuestoIva,
      presupuestoIvaConIva,
      presupuestoRealIva,
      presupuestoSinIva,
      contratoTotalIva,
      anticipoTotalIva,
      totalFiscalIva,
      anticipoNoFiscal,
      presupuestoReal,
      anticipoReal,
      anticipoFiscal,
      totalEstimadoSinAbono,
      totalFiscalIvaSinAbono,
      totalFiscalSinAbono,
      totalNoFiscalSinAbono
    };
  };

  const {
    presupuesto,
    presupuesto_no_iva,
    presupuesto_iva,
    ivaCalculado,
    ivaSinIva,
    ivaConIva,
    ivaPorcentaje,
    ivaFactor,
    montosNoFiscales,
    montosFiscales,
    totalNoFiscal,
    totalFiscal,
    totalEstimado,
    presupuestoRealTotal,
    saldoReal,
    finiquito,
    presupuestoIva,
    presupuestoIvaConIva,
    presupuestoRealIva,
    presupuestoSinIva,
    contratoTotalIva,
    anticipoTotalIva,
    totalFiscalIva,
    anticipoNoFiscal,
    presupuestoReal,
    anticipoReal,
    anticipoFiscal,
    totalEstimadoSinAbono,
    totalFiscalIvaSinAbono,
    totalFiscalSinAbono,
    totalNoFiscalSinAbono
  } = calculateValues();

  const Navigate = (path, params) => {
    navigate(path, params);
  }

  const cancel = e => {console.log(e);};

  {/** VARS MODAL ADD BUDGET **/}
  const [openModalBudget, setOpenModalBudget] = useState(false);

  {/** FUNCTIONS MODAL ADD BUDGET **/}
  const openModalBudgetFunc = () => setOpenModalBudget(true);
  const cancelModalBudgetDialog = () => setOpenModalBudget(false);
  const reloadData = () => {
    console.log("aqui mero se actualiza");
    setOpenModalBudget(false);
  }

  return (
    <>
      <Layout>
        <Content className="primary-container">
            <Breadcrumb 
              className='breadcrumb' 
              items={[
                  { title: <a href="/home">Inicio</a> },
                  { title: "Control de Pagos" }
              ]} 
            />
            <Card style={{ margin: 'auto', marginTop: 16, maxWidth: '900px' }}>
              <div
                className='card-header-custom'>
                  <Typography.Title style={{marginTop:0, marginBottom:0}} level={4}>Control de Pagos</Typography.Title>
                  {
                    (selectedControlPago && controlPago && controlPago.ruta_imagen_presupuesto && controlPago.ruta_imagen_presupuesto !== "") && (
                      <Dropdown
                        menu={{
                          items,
                        }}
                      >
                        <a onClick={(e) => e.preventDefault()}>
                          <Space>
                            Archivo
                            <DownOutlined />
                          </Space>
                        </a>
                      </Dropdown>
                    )
                  }
              </div>
              <Divider style={{ marginBottom: 20 }}/>

              {/* Selección de Contratista */}
              <div style={{ marginBottom: 16 }}>
                <Select
                  placeholder="Seleccionar Contratista"
                  value={selectedContratista || undefined}
                  onChange={handleContratistaChange}
                  style={{ width: '100%' }}
                  loading={loading}
                >
                  {contratistas.map((contratista) => (
                    <Option key={contratista.id} value={contratista.id}>
                      {contratista.nombre_contratista}
                    </Option>
                  ))}
                </Select>
              </div>

              {/* Selección de Control de Pago */}
              {selectedContratista && (
                <>
                  {loading ? (
                    <div style={{ textAlign: 'center', marginBottom: 16 }}>
                      <Spin />
                      <Typography>Cargando controles de pago...</Typography>
                    </div>
                  ) : Array.isArray(controlesDePago) && controlesDePago.length > 0 ? (
                    <div style={{ marginBottom: 16 }}>
                      <Select
                        placeholder="Seleccionar Control de Pago"
                        value={selectedControlPago || undefined}
                        onChange={handleControlPagoChange}
                        style={{ width: '100%' }}
                      >
                        {controlesDePago.map((control) => (
                          <Option key={control.id} value={control.id}>
                            {control.concepto}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  ) : (
                    <Typography>No hay controles de pago disponibles para este contratista.</Typography>
                  )}
                </>
              )}

              {/* Detalles del Control de Pago */}
              {selectedControlPago && (
                <>
                  {loading ? (
                    <div style={{ textAlign: 'center', marginBottom: 16 }}>
                      <Spin />
                      <Typography>Cargando detalles del control de pago...</Typography>
                    </div>
                  ) : controlPago ? (
                    <>
                      <Divider />
                      {/* Sección 1: Datos Generales de la Obra */}
                      <div style={{ marginTop: 25, marginBottom: 16 }}>
                        <h4 className='title-custom'>DATOS GENERALES DE LA OBRA</h4>
                        <Row gutter={[48, 24]}>
                          <GridDatosGenerales 
                            description={controlPago.descripcion}
                            builder={contratistas.find((c) => c.id === controlPago.contratista_id) ?.nombre_contratista}
                            construction={controlPago.nombre_obra}
                            concept={controlPago.concepto}
                            dateContract={controlPago.f_creacion}
                          />
                        </Row>
                      </div>

                      <Divider />
                      
                      {/* Sección 2: Presupuesto Inicial y de Obra */}
                      <div style={{ marginBottom: 16 }}>
                        <Row gutter={[48, 24]} justify="space-between" align="middle">

                          <GridPresupuestoInicial 
                            budget={presupuesto}
                            iva={ivaPorcentaje}
                            budget_iva={presupuesto_iva}
                          />

                          <GridPresupuestoObra 
                            lastBudget={(historical && historical.presupuesto ? historical.presupuesto : presupuesto)}
                            iva={(historical && historical.iva ? historical.iva : ivaPorcentaje)}
                            openModalBudgetFunc={openModalBudgetFunc}
                            budget_iva={(historical && historical.presupuesto_iva ? historical.presupuesto_iva : presupuesto_iva)}
                            deleteBudget={CancelCP}
                          />
                        </Row>
                      </div>

                      <Divider />

                      {/* Sección 3: Contrato sin IVA y Contrato con IVA */}
                      <div style={{ marginBottom: 16 }}>
                        <Row gutter={[48, 24]}>

                            <GridContratoSNIva 
                              budget={(historical && historical.presupuesto ? historical.presupuesto : presupuesto)}
                              budget_not_iva={(historical && historical.presupuesto_no_iva ? historical.presupuesto_no_iva : presupuesto_no_iva)}
                            />

                            <GridContratoIva 
                              budget={(historical && historical.presupuesto ? historical.presupuesto : presupuesto)}
                              budget_iva={(historical && historical.presupuesto_iva ? historical.presupuesto_iva : presupuesto_iva)}
                              budget_not_iva={(historical && historical.presupuesto_no_iva ? historical.presupuesto_no_iva : presupuesto_no_iva)}
                              iva={(historical && historical.iva ? historical.iva : ivaPorcentaje)}
                            />

                        </Row>
                      </div>

                      <Divider />

                      {/* Sección 4: Tablas de Montos */}
                      <div style={{ marginTop: 32 }}>
                        <Row gutter={16}>
                          {/* Tabla de Montos No Fiscales */}
                          <Col xs={24} md={12}>
                            <Typography.Title level={5}>Montos No Fiscales</Typography.Title>
                            <Table
                              dataSource={montosNoFiscales}
                              columns={[
                                {
                                  title: 'RELACIÓN (Semana)',
                                  dataIndex: 'numero_relacion',
                                  key: 'numero_relacion',
                                },
                                {
                                  title: 'MONTO',
                                  dataIndex: 'importe',
                                  key: 'importe',
                                  render: (text) => `$ ${numberFormat.format(text)}`,
                                },
                              ]}
                              size="small"
                              pagination={false}
                              rowKey={(record, index) => index}
                            />
                          </Col>

                          {/* Tabla de Montos Fiscales */}
                          <Col xs={24} md={12}>
                            <Typography.Title level={5}>Montos Fiscales</Typography.Title>
                            <Table
                              dataSource={montosFiscales}
                              columns={[
                                {
                                  title: 'RELACIÓN (Semana)',
                                  dataIndex: 'numero_relacion',
                                  key: 'numero_relacion',
                                },
                                {
                                  title: 'MONTO',
                                  dataIndex: 'importe',
                                  key: 'importe',
                                  render: (text) => `$ ${numberFormat.format(text)}`,
                                },
                                {
                                  title: 'IVA',
                                  key: 'iva',
                                  render: (record) => `$ ${numberFormat.format((record.importe || 0) * ivaFactor)}`,
                                },
                                {
                                  title: 'FINAL',
                                  key: 'final',
                                  render: (record) => `$ ${numberFormat.format((record.importe || 0) + (record.importe || 0) * ivaFactor)}`
                                },
                              ]}
                              size="small"
                              pagination={false}
                              rowKey={(record, index) => index}
                            />
                          </Col>
                        </Row>
                      </div>

                      <Divider />

                      {/* Resumen General */}
                      <div style={{ marginTop: 32 }}>
                      {/* <h4 className='title-custom'>RESUMEN GENERAL</h4> */}
                        <Row gutter={[48, 24]}>
                          
                          <GridResumenGeneral
                            budget={(historical && historical.presupuesto ? historical.presupuesto : presupuesto)}
                            budget_iva={(historical && historical.presupuesto_iva ? historical.presupuesto_iva : presupuesto_iva)}
                            budget_not_iva={(historical && historical.presupuesto_no_iva ? historical.presupuesto_no_iva : presupuesto_no_iva)}
                            advance={anticipoReal}
                            estimadedTotal={totalEstimadoSinAbono}
                          />

                        </Row>
                      </div>

                      <Divider />

                      {/* Resumen Pagos General */}
                      <div style={{ marginTop: 32 }}>
                        <h4 className='title-custom'>RESUMEN GENERAL (CONTRATO)</h4>
                        <Row gutter={[48, 24]}>
                          {/* Presupuesto Contrato 1 */}
                          
                          <GridResumenGeneralContrato 
                            budget={(historical && historical.presupuesto ? historical.presupuesto : presupuesto)}
                            budget_iva={(historical && historical.presupuesto_iva ? historical.presupuesto_iva : presupuesto_iva)}
                            totalFiscal={totalFiscal}
                            advanceFiscal={anticipoFiscal}
                            iva={(historical && historical.iva ? historical.iva : ivaPorcentaje)}
                            advanceFiscalIva={totalFiscalIvaSinAbono}
                          />
                          
                          {/* Presupuesto Contrato 2 */}
                          <GridResumenGeneralContratoSIva 
                            budget={(historical && historical.presupuesto ? historical.presupuesto : presupuesto)}
                            budget_not_iva={(historical && historical.presupuesto_no_iva ? historical.presupuesto_no_iva : presupuesto_no_iva)}
                            advanceNoFiscal={anticipoNoFiscal}
                            totalNoFiscal={totalNoFiscalSinAbono}
                          />

                        </Row>
                      </div>
                    </>
                  ) : (
                    <Typography>No se pudo cargar la información del control de pagos.</Typography>
                  )}
                </>
              )}
              <Divider style={{ margin: '24px 0' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {/* {(selectedControlPago && usuario.privilegios === "Admin") && (
                  <Popconfirm
                  title="Cancelar Control de Pago"
                  description="¿Estás seguro de eliminar este CP?"
                  onConfirm={CancelCP}
                  onCancel={cancel}
                  okText="Sí"
                  cancelText="No"
                >
                  <Button color="danger" variant="outlined">
                    Eliminar
                  </Button>
                </Popconfirm>
                )} */}
                
                
              </div>
            </Card>
        </Content>
      </Layout>
      
      {/** INIT MODAL ADD BUDGET **/}
      {openModalBudget && controlPago && (
        <ModalEditarPresupuestoCmp 
          cp={controlPago}
          contratista={
            contratistas.find((c) => c.id === controlPago.contratista_id)?.nombre_contratista || '-'
          }
          openModalBudget={openModalBudget}
          cancelModalBudgetDialog={cancelModalBudgetDialog}
          reloadData={reloadData}
        />
      )}
      {/** END MODAL ADD BUDGET **/}

    </>
  );
};

export default ControlDePagos;
